module.exports = ".node {\n  cursor: pointer;\n  -webkit-transition: stroke-width 0.1s ease-out,\n      fill 0.1s ease-out,\n      stroke 0.1s ease-out;\n  transition: stroke-width 0.1s ease-out,\n      fill 0.1s ease-out,\n      stroke 0.1s ease-out;\n\n  stroke: white;\n  stroke-width: 0.25;\n}\n\n.node-name {\nfont-family: 'Lato';\ntext-anchor: middle;\nalignment-baseline: central;\nfont-weight: 300;\nfill: white;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/visuals/shared/node-visual/node-visual.component.css
// module id = ./src/app/visuals/shared/node-visual/node-visual.component.css
// module chunks = main